import React, { useEffect } from 'react';
import Gallery from '../Components/Gallery';
import templeimg from '../assets/temple2.png';
import Events from '../Components/Events';
import Location from '../Components/Location';
import footerbg from '../assets/footer.png';
import { useLocation } from 'react-router-dom';

import About from '../Components/About';
import Instagram from '../Components/Icons/Instagram';
import YouTube from '../Components/Icons/Youtube';
import Whatsapp from '../Components/Icons/whatsapp';
import Mail from '../Components/Icons/Mail';
import Facebook from '../Components/Icons/Facebook';
import ramDhun from '../assets/RamDhun.mp3';

export default function TemplePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }

    // const audio = new Audio(ramDhun);
    // audio.volume = 0.5;
    // const handleInteraction = () => {
    //   audio
    //     .play()
    //     .then(() => {
    //       audio.loop = true;
    //     })
    //     .catch((err) => {
    //       console.error('Audio playback failed:', err);
    //     });

    //   window.removeEventListener('click', handleInteraction);
    //   window.removeEventListener('keydown', handleInteraction);
    //   window.removeEventListener('scroll', handleInteraction);
    // };

    // window.addEventListener('scroll', handleInteraction);
    // window.addEventListener('click', handleInteraction);
    // window.addEventListener('keydown', handleInteraction);

    return () => {
      // audio.pause();
      // audio.currentTime = 0;
      // window.removeEventListener('click', handleInteraction);
      // window.removeEventListener('keydown', handleInteraction);
      // window.removeEventListener('scroll', handleInteraction);
    };
  }, [location]);

  return (
    <div
      id="home"
      className="flex flex-col items-center w-full max-md:max-w-full overflow-hidden"
    >
      <div
        className="relative min-h-screen w-full bg-cover bg-center"
        style={{
          backgroundImage: `url(${templeimg})`,
        }}
      >
        <div className="absolute inset-0 bg-[#430F07] bg-opacity-55"></div>
        <div className="relative flex items-center justify-center text-center min-h-screen px-4">
          <div className="text-center p-5 md:p-8 rounded-lg text-white">
            <h1 className="text-[56px] md:text-[60px] font-bold mb-6 tracking-wider leading-tight text-white font-[Noto Sans Devanagari] drop-shadow-[0_2px_4px_rgba(0,0,0,0.9)]">
              जय श्री राम:
            </h1>
            <p className="text-[20px] md:text-[28px]  mb-4 font-afacad">
              Welcome to Jersey City, Hanuman Mandir, a sacred sanctuary for
              devotees, offering a peaceful environment for worship, reflection,
              and community gatherings.
            </p>
            <p className="text-[20px] md:text-[28px] mb-6 font-afacad">
              Join us for daily prayers, special rituals, and festive
              celebrations that honour the spirit of devotion and strength.
            </p>
          </div>
        </div>
      </div>
      <Gallery />

      <section id="event"></section>
      <Events />

      <section id="contact">
        <Location />
      </section>

      <section id="about">
        <About />
      </section>

      <div
        id="footer"
        className="md:mt-20 text-white py-8 w-full h-full bg-cover bg-center bg-no-repeat min-h-[50vh]"
        style={{ backgroundImage: `url(${footerbg})` }}
      >
        <div className="hidden md:block px-10 ">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="w-[28%] bg-[#9B2912] bg-opacity-50 py-10 px-10  mx-10 rounded-lg shadow-lg text-left">
              <h3 className="text-[40px] font-abhaya font-bold mb-4 text-center">
                Aarti Timings
              </h3>
              <h4 className="text-[25px] font-abhaya font-bold mb-4 text-left">
                Saturdays :
              </h4>
              <ul className="list-disc space-y-2 font-[28px] font-afacad">
                <li>Morning Aarti : 9:30 - 10:00AM</li>
                <li>Morning Aarti : 11:30 - 12:00AM</li>
                <li>SunderKaand Paath : 6:00 - 7:30PM</li>
                <li>MahaAarti : 7:30–8:00 PM</li>
                <li>Mahaprasad : 8:00PM Onwards</li>
              </ul>
              <br></br>
              <h4 className="text-[25px] font-abhaya font-bold mb-4 text-left">
                Regular Days :
              </h4>
              <ul className="list-disc space-y-2 font-[28px] font-afacad">
                <li>Evening Aarti 7:00-7:30 PM</li>
              </ul>
            </div>

            {/* Social Media and Footer */}
            <div className="text-center w-[70%] flex flex-col items-center">
              <div className="flex flex-col items-center justify-center">
                <h3 className="text-[50px] font-[Noto Sans Devanagari] mb-4">
                  || जय हनुमान ||
                </h3>
                <h3 className="text-[80px] font-[Noto Sans Devanagari] mb-4">
                  || जय श्री राम ||
                </h3>
              </div>

              <div className="flex justify-around gap-4 w-[60%]">
                <a href="https://www.instagram.com/jaishrihanumantemple?igsh=MTVxOGFudmI5d3phcQ==">
                  <Instagram />
                </a>
                <a href="https://www.facebook.com/share/19oL7SdsiU/?mibextid=wwXIfr">
                  <Facebook />
                </a>
                {/* <a href="https://www.youtube.com">
                  <YouTube />
                </a> */}
                <a href="https://chat.whatsapp.com/BrDOo8I5Yd532Kxja9oeNM">
                  <Whatsapp />
                </a>
                <a href="mailto:jash@gmail.com">
                  <Mail />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="block md:hidden py-4 ">
          <div className=" bg-[#9B2912] bg-opacity-75 py-10 px-10 mx-10 rounded-lg shadow-lg text-left">
            <h3 className="text-[40px] font-abhaya font-bold mb-4 text-center">
              Aarti Timings
            </h3>
            <h3 className="text-[40px] font-abhaya font-bold mb-4 text-center">
              Aarti Timings
            </h3>
            <h4 className="text-[25px] font-abhaya font-bold mb-4 text-left">
              Saturdays :
            </h4>
            <ul className="list-disc space-y-2 font-[28px] font-afacad">
              <li>Morning Aarti : 9:30 - 10:00AM</li>
              <li>Morning Aarti : 11:30 - 12:00AM</li>
              <li>SunderKaand Paath : 6:00 - 7:30PM</li>
              <li>MahaAarti : 7:30–8:00 PM</li>
              <li>Mahaprasad : 8:00PM Onwards</li>
            </ul>
            <br></br>
            <h4 className="text-[25px] font-abhaya font-bold mb-4 text-left">
              Regular Days :
            </h4>
            <ul className="list-disc space-y-2 font-[28px] font-afacad">
              <li>Evening Aarti 7:00-7:30 PM</li>
            </ul>
          </div>

          <div className="flex flex-row justify-center items-center gap-[20px] mt-[30px]">
            <a href="https://www.instagram.com/jaishrihanumantemple?igsh=MTVxOGFudmI5d3phcQ==">
              <Instagram />
            </a>
            <a href="https://www.facebook.com/share/19oL7SdsiU/?mibextid=wwXIfr">
              <Facebook />
            </a>
            {/* <a href="https://www.youtube.com">
              <YouTube />
            </a> */}
            <a href="https://chat.whatsapp.com/BrDOo8I5Yd532Kxja9oeNM">
              <Whatsapp />
            </a>
            <a href="mailto:jash@gmail.com">
              <Mail />
            </a>
          </div>

          <div className="mt-[70px] mb-[100px]">
            <h3 className="text-[50px] font-[Noto Sans Devanagari] mb-4">
              || जय हनुमान ||
            </h3>
            <h3 className="text-[70px] font-[Noto Sans Devanagari] mb-4">
              || जय श्री राम ||
            </h3>
          </div>
        </div>
      </div>

      <div
        id="closing-remarks"
        className="bg-[#430F07] w-[100%] text-white py-2"
      >
        <p className="text-[25px] md:text-[25px]">
          Celebrate your life’s milestones, like Birthdays and Anniversaries,
          with a heartfelt contribution to Sunderkand Path and Mahaprasad.
        </p>
      </div>
    </div>
  );
}
